import storage, { keys } from '~/services/storage'

// localStorage / sessionStorage 공통 제어
export default ({ store, redirect }, inject) => {
  const method = {
    async logout(callback) {
      const result = await store.dispatch('member/LOGOUT')

      if (!result) {
        try {
          store.dispatch('modal/SHOW_ALERT', { content: '로그아웃 실패' })
        } catch (e) {}
        return false
      }

      // 로그인/권한 이동 과정에서 사용하던 임시 경로 정보 제거
      storage.remove(keys.beforePath)
      storage.remove(keys.pathInfo)
      // 네이버 로그인 복귀 처리 등에 사용하던 임시 값 제거
      storage.remove(keys.check)
      storage.remove(keys.count)
      if (typeof callback === 'function') {
        await callback()
      }
      redirect('/')
      return true
    },
  }
  // Nuxt 전역 주입
  inject('method', method)
}